import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
/** @typedef {object} RoutesAdminCourseGroupsRouteProps */

/** @typedef {object} RoutesAdminCourseGroupsRouteState */

/**
 * @extends {ShapeComponent<RoutesAdminCourseGroupsRouteProps, RoutesAdminCourseGroupsRouteState>}
 */
class RoutesAdminCourseGroupsRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="course-groups">
        <Route component="edit" exact path="new" />
        <Route exact path=":course_group_id/edit" />
        <Route component="course-group-courses" exact path=":course_group_id/course_group_courses" />
        <Route component="show" exact path=":course_group_id" />
        <Route component="index" exact />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}

export default memo(shapeComponent(RoutesAdminCourseGroupsRoute))
